import { render, staticRenderFns } from "./SetupWizardComponent.vue?vue&type=template&id=4f39cc21&scoped=true"
import script from "./SetupWizardComponent.vue?vue&type=script&lang=js"
export * from "./SetupWizardComponent.vue?vue&type=script&lang=js"
import style0 from "./SetupWizardComponent.vue?vue&type=style&index=0&id=4f39cc21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f39cc21",
  null
  
)

export default component.exports